
import { useState } from 'react';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/23ab4b98be9e79ab047f49675aba45de.jpg')`
        }}
      />
      
      {/* Content Overlay */}
      <div className="relative z-10 flex items-center min-h-screen">
        <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div className="space-y-6">
                <h1 className="text-5xl lg:text-6xl font-bold leading-tight font-serif text-white">
                  <span className="block">AI Governance</span>
                  <span className="block text-teal-400">Counsel</span>
                </h1>
                
                <h2 className="text-xl lg:text-2xl font-light text-gray-300 leading-relaxed">
                  Translating Complex Ethics & Law into Policy, Foresight, and Liability Mitigation
                </h2>
                
                <p className="text-lg text-gray-400 font-medium">
                  25+ Years of Litigation & Policy Expertise Applied to Your Most Critical AI/Web3 Risk
                </p>
              </div>
              
              {/* CTA Buttons */}
              <div className="space-y-4">
                <button 
                  onClick={() => document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' })}
                  className="w-full bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-alarm-warning-line mr-3"></i>
                  I Need Compliance Now: AI Governance & Risk Audit
                </button>
                
                <button 
                  onClick={() => document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' })}
                  className="w-full bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-shield-check-line mr-3"></i>
                  Get Me Out of the Welfare Trap: Relational AI Risk Advisory
                </button>
              </div>
            </div>
            
            {/* Right Image */}
            <div className="hidden lg:block">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20AI%20governance%20technology%20visualization%20with%20sophisticated%20digital%20compliance%20frameworks%2C%20abstract%20neural%20network%20patterns%20and%20data%20flow%20structures%2C%20professional%20legal-tech%20interface%20designs%20showing%20risk%20assessment%20dashboards%20and%20policy%20management%20systems%2C%20clean%20minimalist%20technology%20aesthetic%20with%20authoritative%20blue%20and%20teal%20color%20schemes%2C%20futuristic%20digital%20governance%20concepts%20with%20geometric%20patterns%20and%20ambient%20lighting&width=600&height=800&seq=hero-tech-portrait&orientation=portrait"
                  alt="AI Governance Technology - Digital Compliance and Risk Management Systems"
                  className="w-full h-auto rounded-lg shadow-2xl object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent rounded-lg"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
      </div>
    </section>
  );
};

export default HeroSection;
